import React from 'react'
import { callCenterPhoneNumber } from '@mobi/utils'
import { SignUpPageHeaderStyled } from './SignUpPageHeader.styled'
import { Button, Icon } from '@mobi/component-library/Common/V2'
import { AppHeaderLogo } from '@mobi/component-library/AppHeader/AppHeaderLogo'
import { useHistory } from '../../../Hooks/useHistory'

type Props = { onHelpClick?: VoidFunction }

export const SignUpPageHeader = ({ onHelpClick }: Props): JSX.Element => {
  const history = useHistory()
  return (
    <SignUpPageHeaderStyled>
      <AppHeaderLogo compactBreakpoint='px375' />
      <Button
        onClick={() => {
          history.push(callCenterPhoneNumber)
          if (onHelpClick) onHelpClick()
        }}
        color='secondary_color'
        size='sm'
      >
        Need Help?
        <Icon name='LinePhoneCall01' />
      </Button>
    </SignUpPageHeaderStyled>
  )
}
